import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Button, Radio,
  Input, Select, InputNumber,
} from 'antd'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormMenu = ({
  handleSubmit, isEdit, isSubmit,
  data, menuList,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (isEdit && data) {
      form.setFieldsValue({
        title: data?.title || '',
        url: data?.url || '',
        parent_id: data?.parent?.id || undefined,
        order_no: data?.order_no,
        target: data?.target,
        status: data?.status || false,
      })
    }
  }, [data])

  const validateMessages = {
    required: "'${label}' is required!", // eslint-disable-line no-template-curly-in-string
  }

  return (
    <div>
      <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
        <h3 className="title-content mb-0">
          {isEdit ? 'Edit' : 'Add'}
          {' '}
          Menu
        </h3>
      </div>
      <Card className="pt-4">
        <Form
          {...formItemLayout}
          form={form}
          name="menu"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input placeholder="Title" />
          </Form.Item>
          <Form.Item label="URL" name="url" rules={[{ required: true }]}>
            <Input placeholder="URL" />
          </Form.Item>
          <Form.Item label="Parent Menu" name="parent_id" rules={[{ required: false }]}>
            <Select
              placeholder="Pilih Parent Menu"
              allowClear={!isEdit}
            >
              {(menuList.data || []).map(item => <Select.Option key={item.id} value={item.id}>{item.title}</Select.Option>)}
            </Select>
          </Form.Item>

          <Form.Item label="Target" name="target" rules={[{ required: false }]}>
            <Select
              placeholder="Target"
              allowClear
            >
              <Select.Option key={1} value="_blank">_blank</Select.Option>
              <Select.Option key={2} value="_self">_self</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Order" name="order_no" rules={[{ required: true }]}>
            <InputNumber placeholder="order" min={1} />
          </Form.Item>

          <Form.Item name="status" label="Status" rules={[{ required: true }]} initialValue="inactive">
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item {...tailLayout} className="btn-primary-wrapper text-right">
            <Button onClick={() => window.history.back()} className="m-r-10" style={{ display: 'inline-block' }}>Cancel</Button>
            <Button type="primary" loading={isSubmit} htmlType="submit">{isEdit ? 'Submit Change' : 'Create'}</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

FormMenu.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmit: PropTypes.bool,
  isEdit: PropTypes.bool,
  data: PropTypes.object,
  menuList: PropTypes.object,
}

export default FormMenu
